<template>
    <div class="informationST">
      <el-row :span="24">
        <el-col :span="24">
          <div class="information">
            <div class="informationCenter">
              <div class="informationTitle" style="display: flex;justify-content: space-between;padding-right: 20px;">
                <Title text="个人信息" />
                <el-button type="primary" @click="changePwdClick">修改密码</el-button>
              </div>
              <div class="informationDiv">
                <div class="informationImgDiv">
                  <el-image v-if="userInfo.thumb" :src="userInfo.thumb" fit="cover" class="informationImg" />
                  <img src="./image/default.jpg" class="informationImg" v-else alt="" />
                  <!--<ComponentUpload :limit="100" @handleChange="handleSuccess">
                    <el-button>点击更换头像</el-button>
                  </ComponentUpload>-->
                </div>
                <ul>
                  <li>
                    <div class="tit">姓名</div>
                    <div class="flex1">{{ userInfo.title | isEmpty }}</div>
                  </li>
                  <li>
                    <div class="tit">助学中心</div>
                    <div class="flex1">
                      {{ userInfo.institution_title | isEmpty }}
                    </div>
                  </li>
                  <li>
                    <div class="tit">联系电话</div>
                    <div class="flex1">
                      {{ userInfo.mobile | formatPhone | isEmpty }}
                    </div>
                    <!-- <i class="iconfont iconxiugai" @click="handleUpdateInfo('联系电话')"></i> -->
                  </li>
                  <li>
                    <div class="tit">身份证号</div>
                    <div class="flex1">
                      {{ userInfo.identity | formatIdCard | isEmpty }}
                    </div>
                  </li>
                  <template>
                    <li>
                      <div class="tit">准考证号</div>
                      <div class="flex1">{{ userInfo.exam_number | isEmpty }}</div>
                    </li>
                  </template>
                  <li>
                    <div class="tit">学号</div>
                    <div class="flex1">
                      {{ userInfo.student_code | isEmpty }}
                    </div>
                  </li>
                  <li>
                    <div class="tit">报考专业</div>
                    <div class="flex1">
                      {{ userInfo.profession_title | isEmpty }}
                    </div>
                  </li>
                  <li>
                    <div class="tit">报考类型</div>
                    <div class="flex1">{{ userInfo.education | isEmpty }}</div>
                  </li>
                  <li>
                    <div class="tit">报考层次</div>
                    <div class="flex1">
                      {{ userInfo.profession_level | isEmpty }}
                    </div>
                  </li>
                  <template v-if="entranceType === 'adult'">
                    <li>
                      <div class="tit">预计毕业时间</div>
                      <div class="flex1">{{ userInfo.expected_graduation_time | isEmpty }}</div>
                    </li>
                  </template>
                  <li>
                    <div class="tit">详细地址</div>
                    <div class="flex1">{{ userInfo.address | isEmpty }}</div>
                    <i class="iconfont iconxiugai" @click="handleUpdateInfo('详细地址')"></i>
                  </li>
                  <li>
                    <div class="tit">紧急联系人</div>
                    <div class="flex1">{{ userInfo.tel | isEmpty }}</div>
                    <i class="iconfont iconxiugai" @click="handleUpdateInfo('紧急联系人')"></i>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
  
      <el-dialog :title="dialogTitle" :visible.sync="centerDialogVisible" width="30%" center>
        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"> </el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="centerDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="handleSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改联系方式" :visible.sync="upPhoneDialogVisible" width="30%" center>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px">
          <el-form-item label="新联系方式" prop="mobile" class="input">
            <el-input type="text" v-model.number="ruleForm.mobile" placeholder="新联系方式"> </el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="ver_code" class="input">
            <el-input type="text" v-model.number="ruleForm.ver_code" placeholder="验证码">
              <el-button class="button_obtain" @click="sendMessage" :disabled="upPhoneMessage" slot="suffix"> {{ upPhoneMessage ? upPhoneMessageSecond + "秒" : "获取验证码" }} </el-button>
            </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="upPhoneDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="UpPhoneSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="修改密码" :visible.sync="changePwdDialogVisible" width="30%" center @close="changePwdDialogClose">
        <el-form :model="changePwdRuleForm" :rules="changePwdRules" ref="changePwdRuleFormRef" label-width="120px">
          <el-form-item label="旧密码" prop="old_password" class="input">
            <el-input type="password" v-model.number="changePwdRuleForm.old_password" show-password placeholder="旧密码"> </el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="new_password" class="input">
            <el-input type="password" v-model.number="changePwdRuleForm.new_password" show-password placeholder="新密码"> </el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="confirm_password" class="input">
            <el-input type="password" v-model.number="changePwdRuleForm.confirm_password" show-password placeholder="确认密码"> </el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="changePwdDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="UchangePwdSubmit">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import { getUserInfo, updateUserInfo, upMailingAddress, confirmStatus, updateMobile, getUserSendCode } from "@/api/basic";
  import { codeServe, userUpPwd } from "@/api/login";
  //import ComponentUpload from "@/components/componentUpload";
  import { setStore } from "@/utils/localStorage";
  import { putObject, deleteObject } from "@/utils/upload";
  import { mobileReg } from "@/utils/regExp";
  
  export default {
    name: "informationST",
    components: {
      //ComponentUpload,
    },
    data() {
      //  密码验证
      const validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else {
          callback();
        }
      };
      //  新密码验证
      const validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.changePwdRuleForm.new_password) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        dialogTitle: "",
        userInfo: {},
        qrCode: "",
        ticket: "",
        majorInfo: "",
        infoImg: "",
        centerDialogVisible: false,
        upPhoneDialogVisible: false,
        textarea: "",
        timer: "",
        name: "",
        ruleForm: {
          mobile: "",
          ver_code: "",
        },
        rules: {
          mobile: [{ required: true, message: "请输入新联系方式", trigger: "blur" }],
          ver_code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        },
        upPhoneMessage: false,
        upPhoneMessageSecond: 60,
        upPhoneMessageTimer: 0,

        // 修改密码
        changePwdDialogVisible: false,
        changePwdRuleForm: {
          old_password: "",
          new_password: "",
          confirm_password: "",
        },
        changePwdRules: {
          old_password: [{ required: true, message: "请输入旧密码", trigger: "blur" }],
          new_password: [{ required: true, validator: validatePass, trigger: "blur" }],
          confirm_password: [{ required: true, validator: validatePass2, trigger: "blur" }],
        }
      };
    },
    computed: {
      entranceType() {
        return localStorage.getItem("_ENTRANCETYPE");
      },
    },
    mounted() {
      this.getUserInfo();
    },
    beforeDestroy() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    methods: {
      // 弹窗 修改密码 关闭
      changePwdDialogClose(){
        this.changePwdRuleForm = {
          old_password: "",
          new_password: "",
          confirm_password: "",
        };
        this.$nextTick(() => {
            this.$refs["changePwdRuleFormRef"].clearValidate();
        });
      },
      // 弹窗 修改密码 提交
      UchangePwdSubmit(){
        this.$refs["changePwdRuleFormRef"].validate((valid) => {
          if (valid) {
            let data = this.changePwdRuleForm;
            userUpPwd(data).then(async res => {
              if (res.code == 200) {
                this.changePwdDialogVisible = false;
                this.$message.success("修改密码成功");
                await this.$store.dispatch('permission/logOut');
                // Cookies.remove('token');
                this.$router.replace("/Login");
              }
            });
          }
        });
      },
      // 点击 修改密码
      changePwdClick(){
        this.changePwdDialogVisible = true;
      },
      // 邮寄地址 确认
      async confirmStatusClick() {
        let res = await confirmStatus();
        if (res.code == 200) {
          this.$message.success("确认成功");
          this.userInfo.confirm_status = 1;
        }
      },
      async getUserInfo() {
        const { result } = await getUserInfo();
        if (result) {
          this.userInfo = result;
        }
      },
      //  编辑个人信息
      handleUpdateInfo(value) {
        this.dialogTitle = value;
        switch (value) {
          case "联系电话":
            this.ruleForm = {
              mobile: "",
              ver_code: "",
            };
  
            this.upPhoneDialogVisible = true;
            //   this.$router.push("/updatePhone");
            break;
          case "紧急联系人":
            this.textarea = this.userInfo.tel;
            this.name = "tel";
            this.centerDialogVisible = true;
            break;
          case "详细地址":
            this.textarea = this.userInfo.address;
            this.name = "address";
            this.centerDialogVisible = true;
            break;
          case "邮寄地址":
            this.textarea = this.userInfo.mailing_address;
            this.name = "mailing_address";
            this.centerDialogVisible = true;
            break;
          default:
            break;
        }
      },
      sendMessage() {
        if (mobileReg.test(this.ruleForm.mobile)) {
          this.upPhoneMessage = true;
          //  发送手机验证码
          getUserSendCode({ mobile: this.ruleForm.mobile });
          this.upPhoneMessageTimer = setInterval(() => {
            this.upPhoneMessageSecond--;
            if (this.upPhoneMessageSecond === 0) {
              this.upPhoneMessage = false;
              this.upPhoneMessageSecond = 60;
              clearInterval(this.upPhoneMessageTimer);
            }
          }, 1000);
        } else {
          this.$message.error("请输入正确的手机号");
        }
      },
      UpPhoneSubmit() {
        this.$refs["ruleForm"].validate(async (valid) => {
          if (valid) {
            let params = this.ruleForm;
            updateMobile(params).then((res) => {
              if (res.code == 200) {
                this.getUserInfo();
                this.$message.success("修改成功");
                this.upPhoneDialogVisible = false;
              }
            });
          } 
        });
      },
      async handleSubmit() {
        let params = {};
        params[this.name] = this.textarea;
        if (this.name === "mailing_address") {
          await this.updateMailingAddress(params);
        } else {
          await this.updateUser(params);
        }
      },
      async updateUser(params) {
        const res = await updateUserInfo(params);
        if (res.code == 200) {
          this.$message.success("修改成功");
          // this.getUserInfo();
          this.userInfo[this.name] = params[this.name];
          this.centerDialogVisible = false;
        }
      },
      // 修改邮寄邮寄地址
      async updateMailingAddress(params) {
        const res = await upMailingAddress(params);
        if (res.code == 200) {
          this.$message.success("修改成功");
          this.getUserInfo();
          // this.userInfo[this.name] = params[this.name];
          this.centerDialogVisible = false;
        }
      },
      //  图片上传成功
      handleSuccess(res) {
        console.log(res);
        // 存在的头像先删除在上传
        if (this.userInfo.thumb) {
          const file = {
            url: this.userInfo.thumb,
          };
          deleteObject(file);
        }
        console.log(res);
  
        putObject(res.file, (url) => {
          if (url) {
            const params = {
              thumb: url,
            };
            this.name = "thumb";
            this.updateUser(params);
          }
        });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .informationST {
    min-height: $menuH;
    padding: 20px 20px 0 20px;
  }
  .informationCenter {
    width: 100%;
    min-height: inherit;
    background-color: #fff;
  }
  .informationTitle {
    display: flex;
    align-items: center;
    padding-left: 20px;
  }
  .informationTitle span {
    display: inline-block;
    width: 4px;
    height: 23px;
    background-color: #1459a6;
  }
  .informationDiv {
    width: 100%;
    display: flex;
    margin-top: 50px;
  }
  .informationDiv .informationImgDiv {
    /*display: flex;*/
    /*justify-content: center;*/
    text-align: center;
  }
  .informationDiv .informationImgDiv .informationImg {
    width: 132px;
    height: 174px;
    margin: 0 64px;
  }
  .informationDiv ul {
    display: flex;
    flex-wrap: wrap;
  }
  .informationDiv ul li {
    width: 460px;
    height: 57px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #efefef;
    margin: 0 0 13px 20px;
  }
  .flex1 {
    @include flex(1);
    color: #343434;
    font-size: 15px;
    margin-right: 30px;
  }
  .tit {
    width: 100px;
    color: #343434;
    font-size: 15px;
    display: flex;
    margin-left: 3px;
  }
  .informationDiv ul li span {
    width: 330px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666;
    font-size: 15px;
    position: relative;
  }
  .informationDiv ul li i {
    color: #cacaca;
    font-size: 30px;
    cursor: pointer;
  }
  .QRdata {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  .QRdataDiv {
    overflow: hidden;
  }
  
  #login_container {
    margin-top: -20px;
  }
  </style>
  